const initialState = {
    loading: false, 
    token: null, 
    error: null
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_AUTH_TOKEN_LOADING':
            return { ...state, loading: true, error: null };
        case 'GET_AUTH_TOKEN_SUCCESS':
            return { ...state, loading: false, token: action.payload };
        case 'GET_AUTH_TOKEN_FAILURE':
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
